import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedBlock } from "../../../slice/document/document-slice";
import { resetContent } from "../../../slice/pdf/pdf-slice";
import RedressDialog from "./components/RedressDialog";
import { checkReqValMode } from "../../../utils/utils";

export default function Redressment() {
	const [open, setOpen] = useState(false);
	const selectedBlock = useSelector(({ srDocument }) => srDocument.selectedBlock);
	const mode = useSelector(({ srDocument }) => srDocument.mode);
	const page = useSelector(({ srPdf }) => srPdf.page);
	const reorderRedressmentFocusActive = useSelector(({ srPdf }) => srPdf.reorderRedressmentFocusActive);
	const dispatch = useDispatch();
	const [isProcessingRedressment, setIsProcessingRedressment] = useState(false);
	const handleCloseRedressDialog = ({ isProcessing = false }) => {
		setIsProcessingRedressment(isProcessing);
		dispatch(setSelectedBlock(null));
	};
	const handleEndProcessingRedressment = () => {
		setIsProcessingRedressment(false);
	};
	const reloadData = () => {
		dispatch(resetContent({ pages: [page, page + 1, page + 2], mode }));
	};
	const handleOpen = (boolOpen) => {
		setOpen(boolOpen);
	};
	useEffect(() => {
		handleOpen(!!selectedBlock);
	}, [selectedBlock]);
	useEffect(
		() => {
			if (reorderRedressmentFocusActive === null && !!selectedBlock && !open) {
				setOpen(true);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[reorderRedressmentFocusActive]
	);
	return (
		<>
			{!checkReqValMode(mode) && (
				<RedressDialog
					isProcessingRedressment={isProcessingRedressment}
					open={open}
					onClose={handleCloseRedressDialog}
					onEndProcessing={handleEndProcessingRedressment}
					onReloadData={reloadData}
					onSimpleClose={() => handleOpen(false)}
				/>
			)}
		</>
	);
}
